const MAX_MS_BETWEEN_ACTIONS = 5 * 60 * 1000; // 5 mins

const calcActiveTime = (times: number[]) => {
    let totalActive = 0;

    const cleanedTimes = Array.from(new Set(times)).sort((a, b) => a - b);

    for (let i = 0; i < cleanedTimes.length - 1; i++) {
        const delta = cleanedTimes[i + 1] - cleanedTimes[i];
        if (delta <= MAX_MS_BETWEEN_ACTIONS) {
            totalActive += delta;
        } else {
            totalActive += MAX_MS_BETWEEN_ACTIONS;
        }
    }

    return totalActive / 1000;
};

export { calcActiveTime };
